import { SymconModuleType } from './interfaces'
import { KnockautHandler } from './knockautHandler'

export interface SymconLibrary {
  LibraryID: string
  Author: string
  URL: string
  Name: string
  Version: number
  Build: number
  Date: number
}

export interface SymconModule {
  Aliases: string[]
  ChildRequirements: string[]
  Implemented: string[]
  LibraryID: string
  ModuleID: string
  ModuleName: string
  ModuleType: SymconModuleType
  ParentRequirements: string[]
  URL: string
  Vendor: string
}

export class KnockautModuleHandler {
  private _knockautHandler: KnockautHandler
  initialized = false

  constructor(knockautHandler: KnockautHandler) {
    this._knockautHandler = knockautHandler
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/modulverwaltung/ips-getlibrarylist/
   */
  public async getLibraryList(): Promise<string[]> {
    return this._knockautHandler.parseKnockautResponse('IPS_GetLibraryList', [])
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/modulverwaltung/ips-getmodule/
   */
  public async getModule(moduleId: string): Promise<SymconModule> {
    return this._knockautHandler.parseKnockautResponse('IPS_GetModule', [
      moduleId,
    ])
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/modulverwaltung/ips-getlibrary/
   */
  public async getLibrary(libraryId: string): Promise<SymconLibrary> {
    return this._knockautHandler.parseKnockautResponse('IPS_GetLibrary', [
      libraryId,
    ])
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/modulverwaltung/ips-getlibrarymodules/
   */
  public async getLibraryModules(libraryId: string): Promise<string[]> {
    return this._knockautHandler.parseKnockautResponse(
      'IPS_GetLibraryModules',
      [libraryId]
    )
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/modulverwaltung/ips-getmodulelist/
   */
  public async getModuleList(): Promise<any[]> {
    return this._knockautHandler.parseKnockautResponse('IPS_GetModuleList', [])
  }

  /**
   * https://www.symcon.de/service/dokumentation/befehlsreferenz/instanzenverwaltung/ips-getinstancelistbymoduleid/
   */
  public async getInstanceListByModuleID(moduleId: string): Promise<any[]> {
    return this._knockautHandler.parseKnockautResponse(
      'IPS_GetInstanceListByModuleID',
      [moduleId]
    )
  }
}
